import "core-js/modules/es6.array.map";
import m from "react";
import n from "clsx";
import { FlyoutLink as o } from "./FlyoutLink";

var h = function h(_ref) {
  var e = _ref.group,
      _ref$isElevated = _ref.isElevated,
      s = _ref$isElevated === void 0 ? !1 : _ref$isElevated,
      t = _ref.groupNumber;
  var a, i;
  return m.createElement("div", {
    className: n("hg-primarynav__submenu-group", {
      "hg-primarynav__submenu-group--elevated": s
    }),
    style: {
      "--primarynav-flyout-group-number": t
    }
  }, m.createElement("h2", {
    id: e.id,
    className: "hg-primarynav__submenu-header"
  }, e.title), m.createElement("ul", {
    className: "hg-primarynav__submenu-list",
    "aria-labelledby": e.id
  }, (a = e.elevatedLinks) == null ? void 0 : a.map(function (r, u) {
    return m.createElement(o, {
      key: r.id,
      link: r,
      isElevated: !0,
      itemNumber: u
    });
  }), (i = e.baseLinks) == null ? void 0 : i.map(function (r, u) {
    var l;
    return m.createElement(o, {
      key: r.id,
      link: r,
      itemNumber: (((l = e.elevatedLinks) == null ? void 0 : l.length) || 0) + u
    });
  })));
};

export { h as FlyoutGroup };